var _defs, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGeorgiaicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53,
    height: 38,
    viewBox: "0 0 53 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    viewBox: "0 0 151 101"
  }, /*#__PURE__*/React.createElement("image", {
    width: 151,
    height: 101,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJcAAABlCAMAAAB3G4FZAAAAZlBMVEX/////AAD/jIz/lZX/7u7/4eH/QUH/ycn/zs7/dHT/g4P/2tr/W1v/6ur/UlL/Bwf/amr/iIj/kJD/KSn/Skr/MzP/GBj/09P/IyP/9fX/uLj/nZ3/enr/mZn/OTn/o6P/v7//srK0MUNdAAACAUlEQVRoge2a63KCMBBGpQIBuXrBKxd9/5csWazOWOvwudHutHv+gBo+DsEJZLKTCZep950pO5WPemGoF4Z6YagXxm94LdtVvqpyx1551ae2S4ZXSGdJHXul1CZkeNUjzoJ7DUfMGF4dJewde+2pTcfwGhISx17JiKt9zJESAsdeAbU5PiMUdFHWbyJK8O0XpvHZXn5j7DVm1Caye1H3+KJvMfbIdRUW/aYIq+JLj+llfysuqWv70UBe0Z2TOfK6IYK8NsWbvIoN5vW2/sK8pN5H423DtKxL+ofGcZm2Wy9je2Xetk3LOKbUPj0Nt+D/3jeJ7Z6h26xQlpgd22tnEsq6dJSfmB/uwmPEjatnpD6HDpRwcux1ojac53ZMCR+OvebUJmZ4VZTwmvfCluFV1rP5rH78Bod7zSi1ZHiNQedDGOqFoV4Y6oUh1au549XwYz+YLPI7XvmCGzu5kyoB9cJQLwz1wlAvDPXCUC8M9cJQLwz1whD7fi91PsRG6vxRvTDUC0O9MNTryivXO/7i+tAr19NqhpfU9Uep67Xi1rel1gNIrZ+QWm8itT5Haj2T1Ps41Mu1Q2Xbymm93LpaDfVy7RP1ckEXXccJu5eZgwOvg7kZJ9D6wjPixtUzUp9DUut9X1MfvaA2nPpoqfXkUuvvx6DzIQz1wlAvDPXC+F9en/C9LVRfUZ/+AAAAAElFTkSuQmCC"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "download",
    width: 53,
    height: 38,
    rx: 3,
    fill: "url(#pattern)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeorgiaicon);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/georgia.icon.8c972e200b78323bcca0e910badc8cdd.svg";
export { ForwardRef as ReactComponent };